import { ReferenceLiteName } from 'reference-resolvers-lite/components/ReferenceLiteName';
import { BUSINESS_UNIT } from 'customer-data-objects/externalOptions/ExternalOptionsReferenceTypes';
import { getBrandId } from 'documents-ui/utils/getBrandId';
import { jsx as _jsx } from "react/jsx-runtime";
const DocumentBrandCell = ({
  searchResult
}) => {
  return /*#__PURE__*/_jsx(ReferenceLiteName, {
    id: getBrandId(searchResult),
    referenceType: BUSINESS_UNIT
  });
};
export default DocumentBrandCell;